import { GlobalStyles as MuiGlobalStyles, useTheme } from '@mui/material';

import { useEffect } from 'react';

export interface GlobalStylesProps {}

function GlobalStyles(props: GlobalStylesProps) {
  const theme = useTheme();

  useEffect(() => {
    // TODO: Support ltr
    document.body.setAttribute('dir', 'rtl');
    // TODO:
    document.documentElement.setAttribute('lang', 'fa');
  }, []);

  return (
    <MuiGlobalStyles
      styles={{
        ':root': {
          '--color-primary': theme.palette.primary.main,
          '--color-secondary': theme.palette.secondary.main,
          '--min-landing-card-horizontal-padding': '16px',
          '--min-total-landing-card-horizontal-padding':
            'calc(2 * var(--min-landing-card-horizontal-padding))',
          '--landing-card-width': '350px',
        },
        body: {
          overflowX: 'hidden',
          position: 'relative',
        },
        '#conversejs, #conversejs-bg, .converse-fullscreen': {
          '--chat-content-background-color': `${theme.palette.grey[100]} !important`,
        },
      }}
    />
  );
}

export default GlobalStyles;
